var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fbd03d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.5333 27.6758h-21.3333c-.7364 0-1.3334.6453-1.3334 1.4414v5.7658c0 .7961.597 1.4414 1.3334 1.4414h21.3333c.7364 0 1.3333-.6453 1.3333-1.4414v-5.7658c0-.7961-.5969-1.4414-1.3333-1.4414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.8667 36.3245h-21.3334c-.7364 0-1.3333.6453-1.3333 1.4414v5.7658c0 .7961.5969 1.4414 1.3333 1.4414h21.3334c.7363 0 1.3333-.6453 1.3333-1.4414v-5.7658c0-.7961-.597-1.4414-1.3333-1.4414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5333 44.9731h-21.3333c-.7364 0-1.3334.6454-1.3334 1.4415v5.7657c0 .7961.597 1.4415 1.3334 1.4415h21.3333c.7364 0 1.3333-.6454 1.3333-1.4415v-5.7657c0-.7961-.5969-1.4415-1.3333-1.4415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.8667 53.6218h-21.3334c-.7364 0-1.3333.6454-1.3333 1.4415v5.7657c0 .7961.5969 1.4415 1.3333 1.4415h21.3334c.7363 0 1.3333-.6454 1.3333-1.4415v-5.7657c0-.7961-.597-1.4415-1.3333-1.4415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.41066 10.3784c-.73637 0-1.33333-.64538-1.33333-1.44146v-5.76576c0-.79608.59696-1.44144 1.33333-1.44144h21.33334c.7364 0 1.3333.64536 1.3333 1.44144v5.76576c0 .79608-.5969 1.44146-1.3333 1.44146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.74399 19.0271c-.73637 0-1.33333-.6454-1.33333-1.4415v-5.7657c0-.7961.59696-1.4415 1.33333-1.4415h21.33331c.7364 0 1.3334.6454 1.3334 1.4415v5.7657c0 .7961-.597 1.4415-1.3334 1.4415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.07731 27.6757c-.73637 0-1.33333-.6453-1.33333-1.4414v-5.7658c0-.796.59696-1.4414 1.33333-1.4414h21.33329c.7364 0 1.3334.6454 1.3334 1.4414v5.7658c0 .7961-.597 1.4414-1.3334 1.4414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.41066 36.3244c-.73637 0-1.33333-.6453-1.33333-1.4414v-5.7658c0-.7961.59696-1.4414 1.33333-1.4414h21.33334c.7364 0 1.3333.6453 1.3333 1.4414v5.7658c0 .7961-.5969 1.4414-1.3333 1.4414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.07731 44.9731c-.73637 0-1.33333-.6454-1.33333-1.4414v-5.7658c0-.7961.59696-1.4414 1.33333-1.4414h21.33329c.7364 0 1.3334.6453 1.3334 1.4414v5.7658c0 .796-.597 1.4414-1.3334 1.4414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.41066 53.6215c-.73637 0-1.33333-.6453-1.33333-1.4414v-5.7658c0-.796.59696-1.4414 1.33333-1.4414h21.33334c.7364 0 1.3333.6454 1.3333 1.4414v5.7658c0 .7961-.5969 1.4414-1.3333 1.4414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.07731 62.2702c-.73637 0-1.33333-.6453-1.33333-1.4414v-5.7658c0-.7961.59696-1.4414 1.33333-1.4414h21.33329c.7364 0 1.3334.6453 1.3334 1.4414v5.7658c0 .7961-.597 1.4414-1.3334 1.4414z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m23.7333 44.9731c-.7364 0-1.3333-.6454-1.3333-1.4414v-5.7658c0-.7961.5969-1.4414 1.3333-1.4414h21.3333c.7364 0 1.3334.6453 1.3334 1.4414v5.7658c0 .796-.597 1.4414-1.3334 1.4414z",
    fill: "#fae978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 53.6218c-.7364 0-1.3334-.6454-1.3334-1.4415v-5.7657c0-.7961.597-1.4415 1.3334-1.4415h21.3333c.7364 0 1.3333.6454 1.3333 1.4415v5.7657c0 .7961-.5969 1.4415-1.3333 1.4415z",
    fill: "#fae978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7333 62.2705c-.7364 0-1.3333-.6454-1.3333-1.4415v-5.7657c0-.7961.5969-1.4415 1.3333-1.4415h21.3333c.7364 0 1.3334.6454 1.3334 1.4415v5.7657c0 .7961-.597 1.4415-1.3334 1.4415z",
    fill: "#fae978"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayments);
export default __webpack_public_path__ + "static/media/icon-payments.a6bd7012be6564814c24b9de2f5a4350.svg";
export { ForwardRef as ReactComponent };